const baseUrl = 'http://schemas.openxmlformats.org'

export const NS = {
    contentTypes: baseUrl + '/package/2006/content-types',
    pkgRels: baseUrl + '/package/2006/relationships',
    docRels: baseUrl + '/officeDocument/2006/relationships',
    main: baseUrl + '/spreadsheetml/2006/main',
}
